import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'

import {Power1, Power2, TweenLite} from "gsap";
import ReactDOM from 'react-dom'


import {TransitionGroup} from 'react-transition-group'

import ResizeSensor from '../../components/ResizeSensor'

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/pro-light-svg-icons/faTimes";
import {closeAnyPopup} from "../../actions/Popup";


class ContentPopup extends Component {

    static propTypes = {
        popupData: PropTypes.object.isRequired,
        onClose: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)
        this.state = {
            popupAlignedTop: false
        }
        this.popupRef = React.createRef();
    }


    componentWillAppear(callback) {
        this.componentWillEnter(callback)
    }

    componentWillEnter(callback) {

        const dom = ReactDOM.findDOMNode(this)
        const popup = this.popupRef.current

        const willBeAlignedTop = this.shouldBeAlignedTop()

        TweenLite.from(dom, 0.75, {
            ease: Power1.easeOut, backgroundColor: "rgba(0,0,0,0)", onComplete: () => {
                TweenLite.set(dom, {clearProps: "all"});
                TweenLite.set(popup, {clearProps: "all"})
                window.addEventListener('click', this.handleDocumentClick)
                window.addEventListener('resize', this.handleResize)
                callback()
            }
        })
        if (willBeAlignedTop) {
            TweenLite.fromTo(popup, 0.35, {opacity: 0, scale: 0.945, y: 0}, {
                delay: 0.35, ease: Power2.easeInOut,
                opacity: 1, scale: 1, y: 0,
                onComplete: () => {
                }
            })
        } else {
            TweenLite.fromTo(popup, 0.35, {opacity: 0, scale: 0.945}, {
                delay: 0.35, ease: Power2.easeInOut,
                opacity: 1, scale: 1,
                onComplete: () => {
                }
            })
        }


    }

    shouldBeAlignedTop = () => {

        const popup = this.popupRef.current
        if (!popup) {
            return false
        }
        return popup.offsetHeight + 40 > window.innerHeight
    }

    handleResize = (e) => {

        if (this.shouldBeAlignedTop()) {
            this.setState({
                popupAlignedTop: true
            })
        } else {
            this.setState({
                popupAlignedTop: false
            })
        }

    }

    handleDocumentClick = (e) => {

        const popup = this.popupRef.current

        if (!popup.contains(e.target)) {
            this.props.onClose()
        }

    }

    componentWillLeave(callback) {

        const dom = ReactDOM.findDOMNode(this)
        const popup = this.popupRef.current

        const wasAlignedTop = this.shouldBeAlignedTop()

        TweenLite.to(dom, 0.75, {
            delay: 0.25,
            ease: Power1.easeOut, backgroundColor: "rgba(0,0,0,0)", onComplete: () => {
                TweenLite.set(dom, {clearProps: "all"});
                TweenLite.set(popup, {clearProps: "all"});
                window.removeEventListener('click', this.handleDocumentClick)
                window.removeEventListener('resize', this.handleResize)
                callback()
            }
        })


        if (wasAlignedTop) {
            TweenLite.fromTo(popup, 0.35, {opacity: 1, y: 0, scale: 1}, {
                ease: Power2.easeOut, opacity: 0, scale: 0.945, y: 0, onComplete: () => {
                }
            })
        } else {
            TweenLite.to(popup, 0.35, {
                ease: Power2.easeOut, opacity: 0, scale: 0.945, onComplete: () => {
                }
            })
        }

    }

    componentWillUnmount() {
        const dom = ReactDOM.findDOMNode(this)
        TweenLite.killTweensOf(dom)
        TweenLite.set(dom, {clearProps: "all"});
        window.removeEventListener('click', this.handleDocumentClick)
        window.removeEventListener('resize', this.handleResize)
    }

    render() {

        return (
            <div className={"content-popup content-popup--" + this.props.popupData.type}>
                <div ref={this.popupRef} className={"content-popup__popup" + (this.state.popupAlignedTop ? ' content-popup__popup--align-top' : ' content-popup__popup--align-center')}>
                    <ResizeSensor onResize={this.handleResize}/>
                    {this.state.popupAlignedTop}
                    <a onClick={(e) => {
                        this.props.onClose()
                    }} className="content-popup__popup__close"><FontAwesomeIcon icon={faTimes}/></a>
                    {this.props.children}
                </div>
            </div>
        )

    }
}

class ContentPopupWrapper extends Component {

    static propTypes = {
        popupData: PropTypes.object.isRequired
    }

    componentDidMount() {
        if (this.props.popupVisible) {
            if (document.body.classList) {
                document.body.classList.add('popup-visible')
            }
        } else {
            if (document.body.classList) {
                document.body.classList.remove('popup-visible')
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.popupVisible) {
            if (document.body.classList) {
                document.body.classList.add('popup-visible')
            }
        } else {
            if (document.body.classList) {
                document.body.classList.remove('popup-visible')
            }
        }
    }

    render() {

        let contentToRender = null

        if (this.props.popupData) {

            switch (this.props.popupData.type) {

                case 'iframe':
                    contentToRender = (
                        <div className="content-popup__popup__iframe-wrapper">
                            <iframe src={this.props.popupData.src}></iframe>
                        </div>
                    )
                    break

                default:
                    contentToRender = null

            }

        }

        return (
            <TransitionGroup component={props => React.Children.toArray(props.children)[0] || null}>
                {this.props.popupVisible ? <ContentPopup onClose={this.props.closePopup} popupData={this.props.popupData}>
                    {contentToRender}
                </ContentPopup> : null}
            </TransitionGroup>
        )

    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        popupVisible: state.contentPopup.popupVisible,
        popupData: state.contentPopup.popupData
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        closePopup: () => {
            dispatch(closeAnyPopup())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentPopupWrapper)



/** WEBPACK FOOTER **
 ** ./src/containers/contentpopup/ContentPopup.js
 **/